import { useTranslation } from "@impero-com/common/utils/i18n";
import { Button, FormBoxCompat } from "@impero-com/ui";
import { Select } from "antd";

import { useControlProgramExport } from "../hooks/useControlProgramExport";

import * as theme from "./theme.css";

const SELECT_ALL_OPTION_VALUE = -1;

interface ControlProgramExporterProps {
    onExport: () => void;
}

export function ControlProgramExporter({
    onExport,
}: ControlProgramExporterProps) {
    const { t } = useTranslation();

    const {
        selectedPrograms,
        setSelectedPrograms,
        programOptions,
        handleSelectAll,
        handleExport,
    } = useControlProgramExport({
        onExport,
    });

    return (
        <div className={theme.exporterContainer}>
            <h3 className={theme.exporterHeader}>
                {t("ControlsBulkAssign_ExportStep_ProgramSelector_Title")}
            </h3>
            <FormBoxCompat>
                <div className={theme.exporterControls}>
                    <Select
                        mode="multiple"
                        className={theme.programSelect}
                        placeholder={t(
                            "ControlsBulkAssign_ExportStep_ProgramSelector_Placeholder"
                        )}
                        value={selectedPrograms}
                        onChange={setSelectedPrograms}
                        options={[
                            {
                                label: t(
                                    "ControlsBulkAssign_ExportStep_ProgramSelector_SelectAll"
                                ),
                                value: SELECT_ALL_OPTION_VALUE,
                                className: theme.selectAllOption,
                            },
                            ...programOptions,
                        ]}
                        onSelect={(value) => {
                            if (value === SELECT_ALL_OPTION_VALUE) {
                                handleSelectAll(true);
                            }
                        }}
                        onDeselect={(value) => {
                            if (value === SELECT_ALL_OPTION_VALUE) {
                                handleSelectAll(false);
                            }
                        }}
                    />
                    <Button
                        variant="primary"
                        onClick={handleExport}
                        disabled={selectedPrograms.length === 0}
                    >
                        {t(
                            "ControlsBulkAssign_ExportStep_ProgramSelector_ContinueButton"
                        )}
                    </Button>
                </div>
            </FormBoxCompat>
        </div>
    );
}
